/* KÔBO — Labo pour-over.
   Différence de fond avec le labo espresso : le temps d'écoulement n'est pas un
   réglage, c'est une conséquence. Sur un V60 on choisit la mouture, la dose et
   l'eau ; la durée, on la subit. Le modèle calcule donc le débit à travers le lit
   de café, puis en déduit la durée, puis le taux d'extraction. */
(function () {
  var root = document.querySelector('[data-k-pour]');
  if (!root) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  var ins = {}, outs = {};
  $$('[data-in]').forEach(function (i) { ins[i.dataset.in] = i; });
  $$('[data-out]').forEach(function (o) { outs[o.dataset.out] = o; });

  var svg = $('.k-lab-svg');
  var stream = $('.kp-stream', svg), water = $('.kp-water', svg), bed = $('.kp-bed', svg),
      liq = $('.kp-liq', svg), drops = $('.kp-drops', svg), bloomG = $('.kp-bloom', svg),
      gramsT = $('.kp-grams', svg), timeT = $('.kp-time', svg), phaseT = $('.kp-phase', svg),
      kettle = $('.kp-kettle', svg);
  var stops = $$('[data-stop]', svg);

  var SRV_TOP = 274, SRV_BOT = 348, SRV_H = SRV_BOT - SRV_TOP;
  var CONE_BOT = 248, CONE_TOP = 158;
  var running = false, raf = 0, SPEED = 14; /* 14× : une infusion de 3 min tient en ~13 s */

  function params() {
    return { g: +ins.grind.value, d: +ins.dose.value, w: +ins.water.value, T: +ins.temp.value, b: +ins.bloom.value };
  }

  function model(p) {
    var ratio = p.w / p.d;
    /* Débit à travers le lit : plus la mouture est grosse, plus ça passe vite ;
       plus le lit est épais (dose élevée), plus ça freine. */
    var flow = 2.6 * Math.pow(p.g / 5.5, 1.15) * Math.pow(15 / p.d, 0.35);
    var bloomWater = Math.min(p.w, p.d * 2);
    var t = p.b + (p.w - bloomWater) / flow;   /* durée totale, floraison comprise */
    /* Extraction : température, finesse, temps de contact et ratio. */
    var E = clamp(20 + 0.34 * (p.T - 93) - 0.55 * (p.g - 5.5) + 0.022 * (t - 115) + 0.30 * (ratio - 16.7), 12, 28);

    var acid = clamp(9 - (E - 16) * 1.1, 0, 10);
    var bitter = clamp((E - 19.5) * 1.5 + (p.T - 93) * 0.12, 0, 10);
    var sweet = clamp(10 - Math.abs(E - 20.5) * 1.6, 0, 10);
    var body = clamp(3 + (18 - ratio) * 0.8 + (5.5 - p.g) * 0.35, 0, 10);

    var v;
    if (E < 18) v = { t: 'Sous-extrait', c: 'under', p: 'Acide, creux, il manque de sucre. Mouds plus fin, monte la température ou verse un peu plus d’eau.' };
    else if (E > 22) v = { t: 'Sur-extrait', c: 'over', p: 'Amer et asséchant. Mouds plus gros pour accélérer l’écoulement, ou baisse la température.' };
    else v = { t: 'Équilibré', c: 'ok', p: 'Acidité, sucrosité et corps se tiennent. Note cette recette : mouture, dose, eau, température.' };

    if (p.T < 88) v.p += ' Sous 88 °C, l’eau n’extrait plus assez, quelle que soit la mouture.';
    if (t > 240) v.p += ' Au-delà de 4 min d’écoulement, le lit est colmaté : mouds plus gros.';
    if (t < 90 && p.w > 200) v.p += ' Moins d’1 min 30 pour ce volume, l’eau traverse sans rien prendre.';
    if (ratio < 13) v.p += ' En dessous de 1:13 c’est très concentré — proche d’un café filtre « fort », pas d’un pour-over classique.';

    return { ratio: ratio, flow: flow, t: t, bloomWater: bloomWater, E: E, acid: acid, bitter: bitter, sweet: sweet, body: body, v: v };
  }

  function mmss(s) {
    /* arrondir AVANT de séparer, sinon 239,6 s donne « 3:60 » au lieu de « 4:00 ». */
    var v = Math.round(s);
    return Math.floor(v / 60) + ':' + String(v % 60).padStart(2, '0');
  }

  function fmt() {
    var p = params(), m = model(p);
    outs.grind.textContent = String(p.g).replace('.', ',');
    outs.dose.textContent = p.d + ' g';
    outs.water.textContent = p.w + ' g';
    outs.temp.textContent = p.T + ' °C';
    outs.bloom.textContent = p.b + ' s';
    $('[data-stat=ratio]').textContent = '1 : ' + m.ratio.toFixed(1).replace('.', ',');
    $('[data-stat=time]').textContent = mmss(m.t);
    $('[data-stat=ext]').textContent = m.E.toFixed(1).replace('.', ',') + ' %';
    return { p: p, m: m };
  }

  function radar(m, k) {
    k = k == null ? 1 : k;
    var pts = [[0, -m.acid * 9], [m.sweet * 9, 0], [0, m.body * 9], [-m.bitter * 9, 0]]
      .map(function (a) { return [a[0] * k, a[1] * k]; });
    $('.k-radar .shape').setAttribute('points', pts.map(function (a) { return a[0].toFixed(1) + ',' + a[1].toFixed(1); }).join(' '));
    $$('.k-radar .dots circle').forEach(function (c, i) { c.setAttribute('cx', pts[i][0]); c.setAttribute('cy', pts[i][1]); });
  }

  function sweetMark(m) { $('[data-sweet]').style.left = clamp((m.E - 14) / 12, 0, 1) * 100 + '%'; }

  function colorFor(E) {
    var t = clamp((E - 14) / 12, 0, 1), a = [201, 138, 74], b = [122, 67, 24], c = [37, 18, 7];
    var mix = function (x, y, k) { return [x[0] + (y[0] - x[0]) * k, x[1] + (y[1] - x[1]) * k, x[2] + (y[2] - x[2]) * k]; };
    var col = t < 0.5 ? mix(a, b, t / 0.5) : mix(b, c, (t - 0.5) / 0.5);
    return 'rgb(' + col.map(Math.round).join(',') + ')';
  }
  function paint(E) {
    stops[0].setAttribute('stop-color', colorFor(E - 4));
    stops[1].setAttribute('stop-color', colorFor(E));
    stops[2].setAttribute('stop-color', colorFor(E + 5));
  }

  /* Recommandation : on ne pousse un produit que s'il répond à un défaut constaté. */
  var recWrap = $('[data-rec-wrap]');
  var REC = {
    'bouilloire-col-de-cygne': 'Ta température sort de la plage utile : une bouilloire réglable la tient au degré.',
    'balance-precision-timer': 'Ton ratio dépend d’une pesée juste : au gramme près, la recette devient reproductible.',
    'cafe-arabica': 'Recette équilibrée — un single origin torréfié moyen est fait pour ce profil.'
  };
  function recommend(p, m) {
    if (!recWrap) return;
    /* Ordre de préférence, pas un choix unique : le produit de la fiche courante
       est absent du DOM (on ne se recommande pas soi-même), il faut donc pouvoir
       retomber sur le suivant au lieu de n'afficher rien. */
    var order = [];
    if (p.T < 88 || p.T > 96) order.push('bouilloire-col-de-cygne');
    if (m.v.c !== 'ok') order.push('balance-precision-timer');
    order.push('cafe-arabica', 'balance-precision-timer', 'bouilloire-col-de-cygne');

    var cards = $$('[data-rec]', recWrap), key = null;
    for (var i = 0; i < order.length && !key; i++) {
      for (var j = 0; j < cards.length; j++) if (cards[j].dataset.rec === order[i]) { key = order[i]; break; }
    }
    cards.forEach(function (c) {
      var on = c.dataset.rec === key;
      c.hidden = !on;
      if (on) { var w = $('[data-rec-why]', c); if (w) w.textContent = REC[key] || ''; }
    });
    recWrap.hidden = !key;
  }

  function setServer(g, max) {
    var h = clamp(g / Math.max(1, max), 0, 1) * SRV_H, y = SRV_BOT + 6 - h;
    liq.setAttribute('y', y); liq.setAttribute('height', h + 6);
    gramsT.textContent = Math.round(g) + ' g';
  }

  function setBedWater(k) {
    /* niveau d'eau au-dessus du lit, dans le cône */
    var h = k * (CONE_BOT - CONE_TOP - 34);
    water.setAttribute('y', CONE_BOT - 34 - h);
    water.setAttribute('height', h);
  }

  function bubble() {
    var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('r', 1 + Math.random() * 2.2);
    c.setAttribute('cx', 205 + Math.random() * 70);
    c.setAttribute('cy', 212 + Math.random() * 20);
    c.setAttribute('fill', '#c79a6a'); c.setAttribute('fill-opacity', '.55');
    bloomG.appendChild(c);
    setTimeout(function () { if (c.parentNode) c.remove(); }, 900);
  }

  function drip(x) {
    var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    c.setAttribute('r', 1.4 + Math.random());
    c.setAttribute('cx', x + (Math.random() - 0.5) * 3);
    c.setAttribute('cy', 250);
    c.setAttribute('fill', '#a86a33');
    c._vy = 0; drops.appendChild(c);
  }

  function reset() {
    cancelAnimationFrame(raf); running = false;
    drops.innerHTML = ''; bloomG.innerHTML = '';
    stream.setAttribute('height', 0);
    setBedWater(0); setServer(0, 1);
    timeT.textContent = '0:00'; phaseT.textContent = 'EN ATTENTE';
    if (kettle) kettle.style.transform = '';
    var s = fmt(); paint(s.m.E); radar(s.m, 1); sweetMark(s.m); recommend(s.p, s.m);
    $('[data-verdict]').className = 'k-verdict';
    $('[data-verdict]').innerHTML = '<b>Prêt à infuser</b><p>Règle la mouture, la dose, l’eau et la température. Le temps d’écoulement, lui, se calcule — sur un V60 on l’observe, on ne le décide pas.</p>';
    $('[data-pour-run] span').textContent = 'Lancer l’infusion';
    root.classList.remove('is-running');
  }

  function verdict(m) {
    var v = $('[data-verdict]');
    v.className = 'k-verdict ' + m.v.c;
    v.innerHTML = '<b>' + m.v.t + '</b><p>' + m.v.p + '</p>';
  }

  function run() {
    if (running) return;
    var s = fmt(), p = s.p, m = s.m;
    running = true; root.classList.add('is-running');
    $('[data-pour-run] span').textContent = 'Infusion…';
    paint(m.E); radar(m, 0.25); sweetMark(m);
    drops.innerHTML = ''; bloomG.innerHTML = '';

    var total = m.t / SPEED, start = performance.now(), lastDrip = 0, lastBub = 0;
    var bloomEnd = p.b / SPEED;

    var loop = function (now) {
      var e = (now - start) / 1000, k = clamp(e / total, 0, 1);
      var elapsed = k * m.t;
      timeT.textContent = mmss(elapsed);

      var inBloom = elapsed < p.b;
      phaseT.textContent = inBloom ? 'FLORAISON' : (k < 1 ? 'VERSAGE' : 'ÉCOULEMENT TERMINÉ');

      /* Filet : coule pendant la floraison puis pendant le versage principal. */
      var pouring = k < 1;
      stream.setAttribute('height', pouring ? 22 : 0);
      stream.setAttribute('width', pouring ? 2 + Math.min(2.5, m.flow * 0.5) : 0);
      if (kettle) kettle.style.transform = pouring ? 'rotate(-9deg)' : '';

      /* Lit gonflé + bulles pendant la floraison */
      if (inBloom) {
        setBedWater(0.18 + 0.1 * Math.sin(e * 6));
        if (now - lastBub > 120) { lastBub = now; bubble(); }
      } else {
        setBedWater(0.32 + 0.12 * Math.sin(e * 3));
      }

      /* Ce qui est déjà tombé dans la carafe : rien pendant la floraison. */
      var poured = inBloom ? 0 : (p.w - m.bloomWater) * ((elapsed - p.b) / Math.max(1, m.t - p.b));
      setServer(clamp(poured, 0, p.w), p.w);

      if (!inBloom && k < 1 && now - lastDrip > 70 / Math.max(0.5, m.flow)) { lastDrip = now; drip(240); }
      $$('circle', drops).forEach(function (c) {
        c._vy += 0.55; var y = +c.getAttribute('cy') + c._vy;
        c.setAttribute('cy', y);
        if (y > SRV_BOT - 8) c.remove();
      });

      radar(m, 0.25 + 0.75 * k);

      if (k < 1) raf = requestAnimationFrame(loop);
      else {
        running = false; root.classList.remove('is-running');
        stream.setAttribute('height', 0); setBedWater(0);
        if (kettle) kettle.style.transform = '';
        setServer(p.w, p.w);
        verdict(m); recommend(p, m);
        $('[data-pour-run] span').textContent = 'Relancer';
      }
    };
    raf = requestAnimationFrame(loop);
  }

  Object.keys(ins).forEach(function (k) {
    ins[k].addEventListener('input', function () {
      if (running) return;
      var s = fmt(); paint(s.m.E); radar(s.m, 1); sweetMark(s.m); recommend(s.p, s.m);
    });
  });
  $('[data-pour-run]').addEventListener('click', function () { if (!running) run(); });
  $('[data-pour-reset]').addEventListener('click', reset);

  reset();
})();
